<template>
  <div class="mine_page">
    <van-nav-bar :title="$t('minepage.member_center')" fixed class="nav-bar"></van-nav-bar>
    <div class="u_bg"></div>
    <div class="content_re">
      <div class="info_card_u">
        <div class="left_c">
          <!-- <div class="user_img_b" v-if="userInfo.header_img">
          <img :src="userInfo.header_img" alt="" class="user_set"/>
        </div> -->
          <div class="user_img_b">
            <img src="/img/neww/userpic.png" alt="" class="user_set" />
          </div>

          <div class="tc">
            <div class="">{{ $t('minepage.account') }}{{ userInfo.username }}</div>
          </div>
        </div>
        <!-- <img src="/img/neww/download (1).png" @click="$router.push({ path: '/IndexInfo' });" class="c_set" /> -->
        <van-icon name="replay" color="#fff" @click="getUserInfo" />
      </div>
      <div class="jifenzhnaghu">
        <div>{{ $t('minepage.points_account') }}</div>
        <div>￥<span>{{ showMoney?userInfo.money:'***' }}</span><van-icon v-show="showMoney" @click="showMoney=false" name="eye-o" /><van-icon v-show="!showMoney" @click="showMoney=true" name="closed-eye" /></div>
      </div>
      <div class="top_bttn" @click="$router.push({ path: '/WithdrawWallet' });">
          <van-icon name="balance-o" color="red" size="22" />
          <div class="text_k">{{ $t('minepage.withdraw') }}</div>
      </div>
      <div style="height: 10px;background-color: transparent;"></div>
      <div class="hang_bttn" @click="$router.push({ path: '/GameRecord' });">
        <div class="left_y">
          <van-icon name="cluster-o" size="24" color="#F297A2"/>
          <div class="text_k">{{ $t('minepage.certification_records') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div class="hang_bttn" @click="$router.push({ path: '/ledger' });">
        <div class="left_y">
          <van-icon name="gold-coin-o" size="24" color="#F297A2" />
          <div class="text_k">{{ $t('minepage.balance_history') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <!-- @click="toNotice()" -->
      <div class="hang_bttn" @click="$router.push({ path: '/WithdrawRecord' });">
        <div class="left_y">
          <van-icon name="cash-back-record-o" size="24" color="#F297A2" />
          <div class="text_k">{{ $t('minepage.withdrawals') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div class="hang_bttn" @click="$router.push({ path: '/RechargeList' });">
        <div class="left_y">
          <van-icon name="refund-o" size="24" color="#F297A2"/>
          <div class="text_k">{{ $t('minepage.deposits') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div style="height: 10px;background-color: transparent;"></div>
      <div class="hang_bttn" @click="$router.push({ path: '/Setting' });">
        <div class="left_y">
          <van-icon name="notes-o" size="24" color="#F297A2" />
          <div class="text_k">{{ $t('minepage.profile') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div class="hang_bttn" @click="$router.push({ path: '/message' });">
        <div class="left_y">
          <van-icon name="comment-o" size="24" color="#F297A2" />
          <div class="text_k">{{ $t('minepage.messages') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div class="hang_bttn" @click="$router.push({ path: '/ServicePage' });">
        <div class="left_y">
          <van-icon name="service-o" size="24" color="#F297A2" />
          <div class="text_k">{{ $t('minepage.support') }}</div>
        </div>
        <van-icon name="arrow" size="18" color="#999" />
      </div>
      <div style="height: 20px;background-color: transparent;"></div>
      <div class="top_bttn" @click="loginout">
          <div class="text_k">{{ $t('minepage.log_out') }}</div>
      </div>
      <div style="height: 20px;background-color: transparent;"></div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      showMoney:true,
      userInfo: {
      },
      menu_top: 40,
      isLoading: false,
    };
  },
   computed: {
    ...mapGetters(['getBaseInfo']),
  },
  methods: {
    loginout(){
      this.$dialog.confirm({
          message: this.$t('minepage.logout_confirm'),
          className: 'noVw',
        }) .then(() => {
          localStorage.clear()
          this.$router.push({path:'/Login'});
        })
        .catch(() => {
          // on cancel
        });
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    // 遗留未使用方法（未被模板引用，跳转旧路径 withdraw），按任务要求注释保留、代码未删除 / legacy unused methods kept as comments
    // doWithdrawal() {
    //   this.$http({
    //     method: 'get',
    //     url: 'user_get_bank'
    //   }).then(res => {
    //     if (res.data.is_bank) {
    //       this.$router.push("withdraw");
    //     } else {
    //       this.$router.push("Setbank");
    //       this.$toast.fail(this.$t("setting.set_bank"));
    //     }
    //   })
    // },
    // toService() {
    //   console.log(this.$store.getters.getBaseInfo)
    //   if (this.$store.getters.getBaseInfo.iskefu == 1) {
    //     this.$router.push("Withdraw");
    //   } else {
    //     this.$toast.fail(this.$t("setting.forbid"));
    //   }
    // },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo, "this.userInfo---174");
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;
}

.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.mine_page {
  position: relative;
  background-color: #f4f4f4;
  top: 100px;
  height: 100vh;
  box-sizing: border-box;

  .content_re {
    position: absolute;
    width: 100%;
    padding-bottom: 100px;

  }

  .header_b {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .u_bg {

    background: rgb(172, 98, 204);
    height: 320px;
    position: absolute;
    width: 100%;
    // z-index: -1;
  }
.jifenzhnaghu{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 34px;
  height: 110px;
  >div{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      margin-right: 20px;
    }
  }
}
.top_bttn{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 32px;
  height: 88px;
  background-color: #fff;
  margin-top: 8px;
  .text_k{
    margin-left: 4px;
  }
}
  .hang_bttn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    border-bottom: 1px solid #eee;
    background-color: #fff;

    .left_y {
      display: inline-flex;
      align-items: center;
      color: #333;

      .cl_set {
        height: 60px;
        margin-right: 20px;
      }
      .text_k{
        margin-left: 20px;
      }
    }

    .right_h {
      height: 34px;
    }
  }

  .c_card_b {
    display: flex;
    align-items: center;
    border-radius: 10px;
    margin: 0 40px;
    padding: 46px 0;

    .hang_c {
      flex: 1;
      text-align: center;

      .q1 {
        color: #fff;
      }

      .q2 {
        color: #e6b98a;
        padding-top: 24px;
      }
    }
  }

  .c_vip {
    margin: 20px 40px;
    background: url('/img/neww/user-bg.png') no-repeat center center;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 40px 40px 40px 40px;
    color: #e6b98a;

    .ee {
      font-size: 24px;
    }

    .down {
      font-size: 28px;
    }
  }

  .info_card_u {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 40px 40px;
    height: 200px;

    .left_c {
      display: inline-flex;
      align-items: center;

      .user_set {
        width: 120px;
        height: auto;
        border-radius: 50%;
      }

      .tc {
        margin-left: 30px;
        color: #fff;

        .c_c {
          padding-top: 16px;
        }
      }
    }

    .c_set {
      width: 40px;
    }
  }

  .c_card_b {
    background-color: #fff;
  }
}



.mine {
  position: relative;
  bottom: 20px;

  /* background: url('/img/usertop.660cec17.png') no-repeat top -16vw center; */
  .page-bg {
    background: linear-gradient(to right, #efcba7, #dcab76);
  }
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mine .header {

  padding-bottom: 100px;
  background-size: contain
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;

}

.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 33.3%;
  height: 180px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;

  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #fff;
  font-size: 32px;
}

.font-gray {
  color: #fff;
  font-size: 28px;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 10px;
}

.mine .wrapper .content .wallet .part-3 {
  display: flex;
  align-items: center;
  height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}

/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.btn {
  margin: 40px 0;
}
</style>
<style lang="less" scoped>
.mine.page {
  padding-top: 50px;
}
</style>
